<div *tuiLet="invites$ | async as invites" class="w-auto">
  @if ((loading$ | async) === false && invites?.length) {
    <tui-island>
      <h2 class="text-xl font-bold block mb-2">
        {{ 'invite.invites' | transloco }}
      </h2>
      <div class="flex flex-col gap-y-2">
        @for (invite of invites; track invite.divisionId) {
          <div
            class="min-w-[500px] w-auto flex gap-x-2 justify-between items-center rounded-xl bg-neutral-100 p-2"
          >
            <div>
              {{ invite.divisionName }}
            </div>
            <button size="m" tuiButton (click)="accept$.next(invite)">
              {{ 'system.action.accept' | transloco }}
            </button>
          </div>
        }
      </div>
    </tui-island>
  }
</div>
